export const data = [
  {
    id: "919628",
    label: "27315 Bass Blvd, Harlingen, TX 78552",
    value: "27315 Bass Blvd, Harlingen, TX 78552",
    street: "27315 Bass Blvd",
    unit: "",
    city: "Harlingen",
    state: "TX",
    zipcode: "78552",
    esiid: "10032789405149985",
    read_schedule: "08",
    premise_type: "Residential",
    duns: "007924772",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "1689347",
    label: "27315 Piney Ranch Ln, Katy, TX 77494",
    value: "27315 Piney Ranch Ln, Katy, TX 77494",
    street: "27315 Piney Ranch Ln",
    unit: "",
    city: "Katy",
    state: "TX",
    zipcode: "77494",
    esiid: "1008901001900452220110",
    read_schedule: "12",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "1771311",
    label: "27315 Horizon Bay Ln, Katy, TX 77494",
    value: "27315 Horizon Bay Ln, Katy, TX 77494",
    street: "27315 Horizon Bay Ln",
    unit: "",
    city: "Katy",
    state: "TX",
    zipcode: "77494",
    esiid: "1008901020901311920117",
    read_schedule: "12",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSM",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "1786045",
    label: "27315 Yellow Rose Ln, Magnolia, TX 77354",
    value: "27315 Yellow Rose Ln, Magnolia, TX 77354",
    street: "27315 Yellow Rose Ln",
    unit: "",
    city: "Magnolia",
    state: "TX",
    zipcode: "77354",
    esiid: "1008901024901145540116",
    read_schedule: "05",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "1815213",
    label: "27315 Whispering Maple Way, Spring, TX 77386",
    value: "27315 Whispering Maple Way, Spring, TX 77386",
    street: "27315 Whispering Maple Way",
    unit: "",
    city: "Spring",
    state: "TX",
    zipcode: "77386",
    esiid: "1008901025001830220121",
    read_schedule: "03",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "1972683",
    label: "27315 Waterford Glen Ln, Katy, TX 77494",
    value: "27315 Waterford Glen Ln, Katy, TX 77494",
    street: "27315 Waterford Glen Ln",
    unit: "",
    city: "Katy",
    state: "TX",
    zipcode: "77494",
    esiid: "1008901022900360430109",
    read_schedule: "12",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "2154358",
    label: "27315 Saxon Meadow Ln, Cypress, TX 77433",
    value: "27315 Saxon Meadow Ln, Cypress, TX 77433",
    street: "27315 Saxon Meadow Ln",
    unit: "",
    city: "Cypress",
    state: "TX",
    zipcode: "77433",
    esiid: "1008901011900209530108",
    read_schedule: "14",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "2255435",
    label: "37315 Donigan Rd A, Brookshire, TX 77423",
    value: "37315 Donigan Rd A, Brookshire, TX 77423",
    street: "37315 Donigan Rd A",
    unit: "",
    city: "Brookshire",
    state: "TX",
    zipcode: "77423",
    esiid: "1008901023900206500108",
    read_schedule: "12",
    premise_type: "Small Non-Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "2399710",
    label: "27315 1/2 Ashton Creek Ln, Katy, TX 77494",
    value: "27315 1/2 Ashton Creek Ln, Katy, TX 77494",
    street: "27315 1/2 Ashton Creek Ln",
    unit: "",
    city: "Katy",
    state: "TX",
    zipcode: "77494",
    esiid: "1008901016901449800118",
    read_schedule: "12",
    premise_type: "Small Non-Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "2466494",
    label: "27315 Walden Gulch Ln, Katy, TX 77494",
    value: "27315 Walden Gulch Ln, Katy, TX 77494",
    street: "27315 Walden Gulch Ln",
    unit: "",
    city: "Katy",
    state: "TX",
    zipcode: "77494",
    esiid: "1008901001900798710114",
    read_schedule: "12",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "2519040",
    label: "27315 Sgt Taylor Memorial, Spring, TX 77386",
    value: "27315 Sgt Taylor Memorial, Spring, TX 77386",
    street: "27315 Sgt Taylor Memorial",
    unit: "",
    city: "Spring",
    state: "TX",
    zipcode: "77386",
    esiid: "1008901006901151320116",
    read_schedule: "03",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSM",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "2529813",
    label: "37315 Bachler Ln, Brookshire, TX 77423",
    value: "37315 Bachler Ln, Brookshire, TX 77423",
    street: "37315 Bachler Ln",
    unit: "",
    city: "Brookshire",
    state: "TX",
    zipcode: "77423",
    esiid: "1008901033740561050100",
    read_schedule: "03",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "2719946",
    label: "27315 Cinco Terrace Dr, Katy, TX 77494",
    value: "27315 Cinco Terrace Dr, Katy, TX 77494",
    street: "27315 Cinco Terrace Dr",
    unit: "",
    city: "Katy",
    state: "TX",
    zipcode: "77494",
    esiid: "1008901006900434170110",
    read_schedule: "12",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "2812737",
    label: "27315 Liberty Heights Ln, Fulshear, TX 77441",
    value: "27315 Liberty Heights Ln, Fulshear, TX 77441",
    street: "27315 Liberty Heights Ln",
    unit: "",
    city: "Fulshear",
    state: "TX",
    zipcode: "77441",
    esiid: "1008901016900828800114",
    read_schedule: "02",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "3021962",
    label: "27315 Onslow Run Dr, Katy, TX 77494",
    value: "27315 Onslow Run Dr, Katy, TX 77494",
    street: "27315 Onslow Run Dr",
    unit: "",
    city: "Katy",
    state: "TX",
    zipcode: "77494",
    esiid: "1008901024900944140115",
    read_schedule: "12",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "3087059",
    label: "173152/3 West Rd, Houston, TX 77095",
    value: "173152/3 West Rd, Houston, TX 77095",
    street: "173152/3 West Rd",
    unit: "",
    city: "Houston",
    state: "TX",
    zipcode: "77095",
    esiid: "1008901022901544160119",
    read_schedule: "09",
    premise_type: "Small Non-Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "3200083",
    label: "27315 Aspen Falls Ln, Fulshear, TX 77441",
    value: "27315 Aspen Falls Ln, Fulshear, TX 77441",
    street: "27315 Aspen Falls Ln",
    unit: "",
    city: "Fulshear",
    state: "TX",
    zipcode: "77441",
    esiid: "1008901022900800610114",
    read_schedule: "02",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "3640801",
    label: "27315 Longbow St, Magnolia, TX 77354",
    value: "27315 Longbow St, Magnolia, TX 77354",
    street: "27315 Longbow St",
    unit: "",
    city: "Magnolia",
    state: "TX",
    zipcode: "77354",
    esiid: "1008901043565523090100",
    read_schedule: "05",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "3988939",
    label: "27315 Pendleton Trace Dr, Spring, TX 77386",
    value: "27315 Pendleton Trace Dr, Spring, TX 77386",
    street: "27315 Pendleton Trace Dr",
    unit: "",
    city: "Spring",
    state: "TX",
    zipcode: "77386",
    esiid: "1008901020900784570113",
    read_schedule: "03",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSR",
    status: "Active",
    power_region: "ERCOT",
  },
  {
    id: "4062335",
    label: "27315 Keystone Bend Ct, Spring, TX 77386",
    value: "27315 Keystone Bend Ct, Spring, TX 77386",
    street: "27315 Keystone Bend Ct",
    unit: "",
    city: "Spring",
    state: "TX",
    zipcode: "77386",
    esiid: "1008901011900091360107",
    read_schedule: "03",
    premise_type: "Residential",
    duns: "957877905",
    amsr: "AMSM",
    status: "Active",
    power_region: "ERCOT",
  },
];

export const top100Films = [
  { label: "The Shawshank Redemption", year: 1994 },
  { label: "The Godfather", year: 1972 },
  { label: "The Godfather: Part II", year: 1974 },
  { label: "The Dark Knight", year: 2008 },
  { label: "12 Angry Men", year: 1957 },
  { label: "Schindler's List", year: 1993 },
  { label: "Pulp Fiction", year: 1994 },
  {
    label: "The Lord of the Rings: The Return of the King",
    year: 2003,
  },
  { label: "The Good, the Bad and the Ugly", year: 1966 },
  { label: "Fight Club", year: 1999 },
  {
    label: "The Lord of the Rings: The Fellowship of the Ring",
    year: 2001,
  },
  {
    label: "Star Wars: Episode V - The Empire Strikes Back",
    year: 1980,
  },
  { label: "Forrest Gump", year: 1994 },
  { label: "Inception", year: 2010 },
  {
    label: "The Lord of the Rings: The Two Towers",
    year: 2002,
  },
  { label: "One Flew Over the Cuckoo's Nest", year: 1975 },
  { label: "Goodfellas", year: 1990 },
  { label: "The Matrix", year: 1999 },
  { label: "Seven Samurai", year: 1954 },
  {
    label: "Star Wars: Episode IV - A New Hope",
    year: 1977,
  },
  { label: "City of God", year: 2002 },
  { label: "Se7en", year: 1995 },
  { label: "The Silence of the Lambs", year: 1991 },
  { label: "It's a Wonderful Life", year: 1946 },
  { label: "Life Is Beautiful", year: 1997 },
  { label: "The Usual Suspects", year: 1995 },
  { label: "Léon: The Professional", year: 1994 },
  { label: "Spirited Away", year: 2001 },
  { label: "Saving Private Ryan", year: 1998 },
  { label: "Once Upon a Time in the West", year: 1968 },
  { label: "American History X", year: 1998 },
  { label: "Interstellar", year: 2014 },
  { label: "Casablanca", year: 1942 },
  { label: "City Lights", year: 1931 },
  { label: "Psycho", year: 1960 },
  { label: "The Green Mile", year: 1999 },
  { label: "The Intouchables", year: 2011 },
  { label: "Modern Times", year: 1936 },
  { label: "Raiders of the Lost Ark", year: 1981 },
  { label: "Rear Window", year: 1954 },
  { label: "The Pianist", year: 2002 },
  { label: "The Departed", year: 2006 },
  { label: "Terminator 2: Judgment Day", year: 1991 },
  { label: "Back to the Future", year: 1985 },
  { label: "Whiplash", year: 2014 },
  { label: "Gladiator", year: 2000 },
  { label: "Memento", year: 2000 },
  { label: "The Prestige", year: 2006 },
  { label: "The Lion King", year: 1994 },
  { label: "Apocalypse Now", year: 1979 },
  { label: "Alien", year: 1979 },
  { label: "Sunset Boulevard", year: 1950 },
  {
    label:
      "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
    year: 1964,
  },
  { label: "The Great Dictator", year: 1940 },
  { label: "Cinema Paradiso", year: 1988 },
  { label: "The Lives of Others", year: 2006 },
  { label: "Grave of the Fireflies", year: 1988 },
  { label: "Paths of Glory", year: 1957 },
  { label: "Django Unchained", year: 2012 },
  { label: "The Shining", year: 1980 },
  { label: "WALL·E", year: 2008 },
  { label: "American Beauty", year: 1999 },
  { label: "The Dark Knight Rises", year: 2012 },
  { label: "Princess Mononoke", year: 1997 },
  { label: "Aliens", year: 1986 },
  { label: "Oldboy", year: 2003 },
  { label: "Once Upon a Time in America", year: 1984 },
  { label: "Witness for the Prosecution", year: 1957 },
  { label: "Das Boot", year: 1981 },
  { label: "Citizen Kane", year: 1941 },
  { label: "North by Northwest", year: 1959 },
  { label: "Vertigo", year: 1958 },
  {
    label: "Star Wars: Episode VI - Return of the Jedi",
    year: 1983,
  },
  { label: "Reservoir Dogs", year: 1992 },
  { label: "Braveheart", year: 1995 },
  { label: "M", year: 1931 },
  { label: "Requiem for a Dream", year: 2000 },
  { label: "Amélie", year: 2001 },
  { label: "A Clockwork Orange", year: 1971 },
  { label: "Like Stars on Earth", year: 2007 },
  { label: "Taxi Driver", year: 1976 },
  { label: "Lawrence of Arabia", year: 1962 },
  { label: "Double Indemnity", year: 1944 },
  {
    label: "Eternal Sunshine of the Spotless Mind",
    year: 2004,
  },
  { label: "Amadeus", year: 1984 },
  { label: "To Kill a Mockingbird", year: 1962 },
  { label: "Toy Story 3", year: 2010 },
  { label: "Logan", year: 2017 },
  { label: "Full Metal Jacket", year: 1987 },
  { label: "Dangal", year: 2016 },
  { label: "The Sting", year: 1973 },
  { label: "2001: A Space Odyssey", year: 1968 },
  { label: "Singin' in the Rain", year: 1952 },
  { label: "Toy Story", year: 1995 },
  { label: "Bicycle Thieves", year: 1948 },
  { label: "The Kid", year: 1921 },
  { label: "Inglourious Basterds", year: 2009 },
  { label: "Snatch", year: 2000 },
  { label: "3 Idiots", year: 2009 },
  { label: "Monty Python and the Holy Grail", year: 1975 },
];
